import { RootState } from "@services/Redux";
import * as React from "react";
import { useSelector } from "react-redux";
import Styled from "./styled";
import noimage from "@assets/img/noimage.jpeg";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import TopbarOrderButton from "@components/TopbarCartButton";
import { useSearchParams } from "react-router-dom";
import { IoChevronBack } from "react-icons/io5";

export const CompanyHeader: React.FC = () => {
  const { logo_image, id, name } = useSelector((state: RootState) => state.company.data);
  const [params] = useSearchParams();

  React.useEffect(() => {
    if (params.get("webview")) {
      localStorage.setItem("webview", "1");
    }
    const source = params.get("source");
    if (source) {
      localStorage.setItem("source", source);
    }
  }, [params]);

  const handleWebviewBackButtonClick = () => {
    let w = window as any;
    w.ReactNativeWebView.postMessage("close");
  };

  return (
    <Styled.HeaderContainer className={"px-2"}>
      {localStorage.getItem("webview") || params.get("webview") ? (
        <Styled.LogoContainer className={"col-6"} onClick={handleWebviewBackButtonClick}>
          <IoChevronBack size={22} color={"black"} />
          <span className={"ms-2"}>Voltar</span>
        </Styled.LogoContainer>
      ) : (
        <Styled.LogoContainer
          className={"col-6"}
          onClick={() => {
            window.location.reload();
          }}
        >
          <Styled.Logo src={logo_image ? `${logo_image.base_url}/companies/${id}/media/thumb_1/${logo_image.key}` : noimage} />
          <span className={"ms-2"}>{name}</span>
        </Styled.LogoContainer>
      )}

      <Styled.OrderButtonContainer className={"col-6"}>
        <TopbarOrderButton />
      </Styled.OrderButtonContainer>
    </Styled.HeaderContainer>
  );
};

export const CompanyBanner: React.FC = () => {
  const { banners, id } = useSelector((state: RootState) => state.company.data);

  return (
    <div className={"p-0 mt-2"}>
      <Carousel infiniteLoop autoPlay showThumbs={false} showStatus={false} showArrows={false} dynamicHeight={true} preventMovementUntilSwipeScrollTolerance={true}>
        {banners.map((banner) => (
          <div key={banner.id}>
            <img alt="banner-img" src={`${banner.base_url}/companies/${id}/media/thumb_3/${banner.key}`} height={"100%"} style={{ objectFit: "cover", maxHeight: 300 }} />
          </div>
        ))}
      </Carousel>
    </div>
  );
};
